import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsIcon from '@mui/icons-material/Payments';
import QrCode2Icon from '@mui/icons-material/QrCode2';

export function IconePagamento({ forma }: { forma: string }): JSX.Element {
  switch (forma) {
    case 'DINHEIRO':
      return <AttachMoneyIcon />;
    case 'CARTAO':
      return <CreditCardIcon />;
    case 'PIX':
      return <QrCode2Icon />;
    default:
      return <PaymentsIcon />;
  }
}
